import React, { useMemo } from "react";
import { Icon, Flex, Text } from "@jsq/ds/core";
import { RequestedDocumentType, DocumentType } from "../../../graphql/supergraph.index";
import { infoLabelWrapper } from "./style_vanilla.css";
import { getDocumentStatusInfo } from "./utils";

type DocumentStatusLabelProps = {
  documentTypes: RequestedDocumentType[];
  documents: DocumentType[];
};

export const DocumentStatusLabel: React.FC<DocumentStatusLabelProps> = ({
  documentTypes = [],
  documents = [],
}) => {
  const statusInfo = useMemo(
    () => getDocumentStatusInfo(documentTypes, documents),
    [documentTypes, documents],
  );

  return (
    statusInfo && (
      <Flex className={infoLabelWrapper} aria-live="polite" role="status">
        <Icon
          type={statusInfo.iconType}
          size="small"
          color={statusInfo.color}
          variant="outline"
          aria-hidden="true"
        />
        <Text variant="secondary-sm" color={statusInfo.color}>
          {statusInfo.message}
        </Text>
      </Flex>
    )
  );
};
